<div id="dialog-container" class="dialog-container">
    <div cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="dialog-header">
        <h4>{{ 'dialog.reports.uploadSignature' | translate }}</h4>
        <button type="button" (click)="dialogRef.close()" class="icon-close"></button>
    </div>
    <div class="container">
        <div class="section-container content">
            <span>{{ 'dialog.reports.signForResponsible' | translate }}</span>
        </div>
        <div class="section-container">
            @if (!report.signDocuments?.length) {
                <sag-ui-filedrop
                    class="file-drop"
                    accept="application/pdf"
                    [multiple]="false"
                    [(ngModel)]="report.signDocuments"
                    (change)="setSignedDocuments($event)"
                >
                    <span class="icon-upload"></span>
                    <p>
                        <b>Click to upload</b>
                        or drag and drop
                    </p>
                    <p class="accepted-files-text">Accepted file types: PDF</p>
                </sag-ui-filedrop>
            } @else {
                <div class="uploaded-document">
                    @let file = getFile();
                    <div class="uploaded-document-item">
                        <span class="document-close icon-close" (click)="removeSignedDocument()"></span>
                        <span class="document-icon icon-document-pdf"></span>
                        <div class="document-name">{{ file.name }}</div>
                        <div class="document-metadata">
                            <span>{{ getFileLastModifiedDate(file) | date: 'dd-MM-yyyy' }}</span>
                            <span>{{ getFileSize(file) }} MB</span>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
    <div class="container container--sticky-bottom">
        <div class="section-container button-container">
            <sag-ui-button color="secondary" (click)="dialogRef.close()">
                {{ 'default.buttons.cancel' | translate }}
            </sag-ui-button>
            <sag-ui-button color="primary" [disabled]="!report?.signDocuments?.length" (click)="uploadSignature()">
                {{ 'default.buttons.confirm' | translate }}
            </sag-ui-button>
        </div>
    </div>
</div>
